"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _excluded = ["color", "size", "className", "children"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var PersonIcon = function PersonIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      className = _ref.className,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, _excluded);

  var classes = 'calcite-icon';
  if (className) classes += " ".concat(className);

  if (size <= 16) {
    return /*#__PURE__*/_react["default"].createElement("svg", _extends({}, props, {
      width: size,
      height: size,
      fill: color,
      viewBox: "0 0 16 16",
      className: classes
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M7.1 1.5A1.399 1.399 0 0 1 8.5.1l.052.001h.052a1.4 1.4 0 0 1 .001 2.8l-.053-.002L8.5 2.9a1.4 1.4 0 0 1-1.4-1.4zm-.973 3.552L5.114 9.105a.546.546 0 0 0 1.033.318l.932-3.265v2.947l-.453 6.347a.511.511 0 0 0 1.015.12l.911-5.484.912 5.484a.511.511 0 0 0 1.014-.12l-.452-6.347V6.158l.931 3.265a.546.546 0 0 0 1.034-.318l-1.013-4.053A1.389 1.389 0 0 0 9.63 4H7.474a1.389 1.389 0 0 0-1.347 1.052z"
    }));
  }

  if (size <= 24) {
    return /*#__PURE__*/_react["default"].createElement("svg", _extends({}, props, {
      width: size,
      height: size,
      fill: color,
      viewBox: "0 0 24 24",
      className: classes
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M13.9 2.999A1.9 1.9 0 1 1 12 1.1a1.9 1.9 0 0 1 1.9 1.899zM13.544 6h-3.088a1.855 1.855 0 0 0-1.8 1.405l-1.662 6.652a.667.667 0 0 0 .14.573.873.873 0 0 0 .665.33.718.718 0 0 0 .653-.445L10 9.1V13l-.922 9.219a.71.71 0 0 0 .707.781h.074a.69.69 0 0 0 .678-.563L12 14.583l1.463 7.854a.69.69 0 0 0 .678.563h.074a.71.71 0 0 0 .707-.781L14 13V9.1l1.548 5.415a.718.718 0 0 0 .653.444.873.873 0 0 0 .665-.329.667.667 0 0 0 .14-.573l-1.662-6.652A1.855 1.855 0 0 0 13.544 6z"
    }));
  }

  return /*#__PURE__*/_react["default"].createElement("svg", _extends({}, props, {
    width: size,
    height: size,
    fill: color,
    viewBox: "0 0 32 32",
    className: classes
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M14 4.5A2.5 2.5 0 1 1 16.5 7 2.499 2.499 0 0 1 14 4.5zM18.646 8h-4.293a2.75 2.75 0 0 0-2.668 2.085l-1.97 7.902a.88.88 0 0 0 .186.755 1.134 1.134 0 0 0 .864.428.94.94 0 0 0 .855-.587L13.512 12v6l-.907 10.917A1 1 0 0 0 13.602 30h.087a1 1 0 0 0 .98-.804l1.83-10.179 1.83 10.178a1 1 0 0 0 .981.805h.087a1 1 0 0 0 .997-1.083L19.487 18v-6l1.892 6.583a.94.94 0 0 0 .855.587 1.134 1.134 0 0 0 .864-.428.88.88 0 0 0 .185-.755l-1.969-7.902A2.75 2.75 0 0 0 18.646 8z"
  }));
};

var _default = PersonIcon;
exports["default"] = _default;